var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import BusinessUnit from './Model';
import { action, observable } from 'mobx';
import { api } from 'helpers/Api';
export default class default_1 {
    constructor() {
        this.data = [];
        this.loaded = false;
        this.set = (values) => {
            this.data = values.map((item) => new BusinessUnit(item));
            this.loaded = true;
            return this.data;
        };
        this.push = (value) => {
            this.data.push(new BusinessUnit(value));
            return this.data;
        };
        this.replace = (value) => {
            this.data.splice(this.data.findIndex(f => f.id === value.id), 1, value);
            return this.data;
        };
        this.splice = (value) => {
            // console.log('BusinessUnits/Store - splice - value: ', value)
            this.data.splice(this.data.findIndex(f => f.id === value), 1);
            return this.data;
        };
    }
    read(id) {
        // console.log('BusinessUnits/Store - read')
        if (id)
            return api.get('businessunits/' + id).then(value => {
                // console.log('BusinesUnits/Store - read(id) - value: ', value)
                // value.image = value.image + '?dummy=' + makeid(3)
                return value;
                // return new BusinessUnit(value)
            });
        return api.get('businessunits').then((value) => {
            // console.log('value', value)
            return this.set(value);
            // return value
        });
    }
    create(value) {
        return api.post('businessunits', value).then(this.push);
    }
    update(id, value) {
        return api.put('businessunits/' + id, value).then(this.replace);
    }
    delete(id) {
        return api.delete('businessunits/' + id).then(this.splice);
    }
    findById(id) {
        return this.data.filter(value => value.id === id)[0];
    }
}
__decorate([
    observable
], default_1.prototype, "data", void 0);
__decorate([
    observable
], default_1.prototype, "loaded", void 0);
__decorate([
    action
], default_1.prototype, "set", void 0);
__decorate([
    action
], default_1.prototype, "push", void 0);
__decorate([
    action
], default_1.prototype, "replace", void 0);
__decorate([
    action
], default_1.prototype, "splice", void 0);



//////////////////
// WEBPACK FOOTER
// ./src/modules/BusinessUnits/Store.ts
// module id = 345
// module chunks = 0